// src/i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
    .use(Backend) // �aduje t�umaczenia z serwera (z folderu /public)
    .use(LanguageDetector) // Wykrywa j�zyk przegl�darki u�ytkownika
    .use(initReactI18next) // Inicjalizuje i18next dla Reacta
    .init({
        load: 'languageOnly',
        fallbackLng: 'pl', // J�zyk u�ywany, gdy inny jest niedost�pny
        debug: true,       // Pokazuje logi w konsoli deweloperskiej
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;